import { render, staticRenderFns } from "./bookingInstructions.vue?vue&type=template&id=635b6803&scoped=true&"
import script from "./bookingInstructions.vue?vue&type=script&lang=js&"
export * from "./bookingInstructions.vue?vue&type=script&lang=js&"
import style0 from "./bookingInstructions.vue?vue&type=style&index=0&id=635b6803&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b6803",
  null
  
)

export default component.exports